module.exports = __webpack_public_path__ + "img/bg_1.4496ee3e.png";